import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router"
import { AuthProvider } from "@/lib/auth"
import { ToastProvider } from "@stayframe/ui"
import { App } from "@/App"
import { initPostHog } from "@/lib/posthog"
import "@stayframe/ui/tokens.css"
import "@/styles/tailwind.css"
import "@/styles/app.css"

initPostHog()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
